module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui small modal",
    attrs: {
      "id": "modal-reorder"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n    Reorder " + _vm._s(_vm.payload.target) + " in " + _vm._s(_vm.payload.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui fluid vertical menu"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.payload.items
    },
    on: {
      "end": _vm.reorder
    }
  }, _vm._l((_vm.payload.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "ui positive button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Done")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a2c5068!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/ModalReorder.vue
// module id = 221
// module chunks = 2